export default "__VITE_ASSET__8952cac9__"